export const opencodeModels = {
    id: "opencode",
    name: "opencode",
    api: "https://opencode.ai/zen/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://opencode.ai/docs",
    env: ["OPENCODE_API_KEY"],
    models: {
        "claude-3-5-haiku": {
            id: "claude-3-5-haiku",
            name: "Claude Haiku 3.5",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07-31",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.8,
                output: 4,
                cache_read: 0.08,
                cache_write: 1,
            },
            limit: {
                context: 200000,
                output: 8192,
            },
        },
        "claude-sonnet-4": {
            id: "claude-sonnet-4",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                reasoning: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "grok-code": {
            id: "grok-code",
            name: "Grok Code Fast 1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-20",
            last_updated: "2025-08-20",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0,
                output: 0,
                cache_read: 0,
                cache_write: 0,
            },
            limit: {
                context: 256000,
                output: 32000,
            },
        },
        "claude-opus-4-1": {
            id: "claude-opus-4-1",
            name: "Claude Opus 4.1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                reasoning: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "gpt-5": {
            id: "gpt-5",
            name: "GPT-5",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-09-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                reasoning: 10,
                cache_read: 0.125,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "kimi-k2": {
            id: "kimi-k2",
            name: "Kimi K2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-09-05",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.5,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "qwen3-coder": {
            id: "qwen3-coder",
            name: "Qwen3 Coder",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.45,
                output: 1.8,
            },
            limit: {
                context: 262144,
                output: 65536,
            },
        },
    },
};
export default opencodeModels;
//# sourceMappingURL=opencode.js.map